import React, { useState } from 'react';
import styled from 'styled-components';

const ComplimentsContainer = styled.div`
  padding: 60px 20px;
  max-width: 1200px;
  margin: 0 auto;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
  margin-bottom: 20px;
  position: relative;
`;

const ComplimentsTitle = styled.h1`
  text-align: center;
  margin-bottom: 50px;
  color: var(--primary-color);
  font-size: 2.8rem;
`;

const ComplimentsDescription = styled.p`
  text-align: center;
  max-width: 800px;
  margin: 0 auto 40px;
  font-size: 1.1rem;
  color: var(--dark-text);
  line-height: 1.6;
`;

const ComplimentsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 25px;
`;

const ComplimentCard = styled.div`
  background-color: #fff;
  border-radius: 10px;
  padding: 25px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(5px);
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  }
`;

const ComplimentText = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  color: var(--dark-text);
  font-style: italic;
  margin-bottom: 0;
  position: relative;
  z-index: 1;
  padding: 10px 15px;
  
  &::before {
    content: '"';
    position: absolute;
    top: -15px;
    left: -5px;
    font-size: 3rem;
    color: var(--primary-color);
    opacity: 0.4;
    font-family: 'Playfair Display', serif;
    z-index: 0;
    display: block;
  }
  
  &::after {
    content: '"';
    position: absolute;
    bottom: -30px;
    right: -5px;
    font-size: 3rem;
    color: var(--primary-color);
    opacity: 0.4;
    font-family: 'Playfair Display', serif;
    z-index: 0;
    display: block;
  }
`;

const AuthorText = styled.p`
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--accent-color);
  text-align: right;
  margin-top: 15px;
  font-style: normal;
`;

const SourceText = styled.span`
  font-size: 0.8rem;
  font-weight: normal;
  font-style: italic;
  color: var(--dark-text);
  opacity: 0.8;
`;

const CopyButton = styled.button`
  position: absolute;
  bottom: 10px;
  right: 10px;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s ease;
  
  ${ComplimentCard}:hover & {
    opacity: 1;
  }
  
  &:hover {
    background-color: var(--accent-color);
  }
`;

const FilterContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
  gap: 10px;
`;

const FilterButton = styled.button`
  background-color: ${props => props.active ? 'var(--primary-color)' : 'transparent'};
  color: ${props => props.active ? 'white' : 'var(--dark-text)'};
  border: 1px solid var(--primary-color);
  padding: 8px 16px;
  margin: 0 5px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: ${props => props.active ? 'var(--primary-color)' : 'rgba(74, 144, 226, 0.1)'};
  }
`;

const TabsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  flex-wrap: wrap;
  gap: 15px;
  padding: 0 20px;
`;

const TabButton = styled.button`
  background-color: ${props => props.active ? 'var(--primary-color)' : 'transparent'};
  color: ${props => props.active ? 'white' : 'var(--dark-text)'};
  border: none;
  border-radius: 12px;
  padding: 14px 28px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: ${props => props.active ? '0 4px 12px rgba(0, 0, 0, 0.15)' : 'none'};
  position: relative;
  overflow: hidden;
  
  &:hover {
    background-color: ${props => props.active ? 'var(--primary-color)' : 'transparent'};
    transform: translateY(-2px);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
    
    &::before {
      opacity: 1;
    }
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${props => props.active ? 
      'none' : 
      'linear-gradient(135deg, rgba(100, 180, 255, 0.8), rgba(30, 90, 200, 0.9))'};
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: -1;
    border-radius: 12px;
  }
  
  &:hover:not(:active) {
    color: ${props => props.active ? 'white' : 'white'};
  }
`;

// Liste des compliments originaux
const complimentsList = [
  {
    id: 1,
    text: "Papa, tu es mon héros de tous les jours, celui qui m'inspire à devenir meilleur.",
    category: "inspirant"
  },
  {
    id: 2,
    text: "Ta sagesse et ta patience font de toi le meilleur guide qu'un enfant puisse avoir.",
    category: "sagesse"
  },
  {
    id: 3,
    text: "Ton courage face aux défis de la vie est une leçon que je n'oublierai jamais.",
    category: "courage"
  },
  {
    id: 4,
    text: "Merci d'être toujours là pour me soutenir, même quand je ne le demande pas.",
    category: "soutien"
  },
  {
    id: 5,
    text: "Ton dévouement envers notre famille est un exemple que j'espère suivre un jour.",
    category: "famille"
  },
  {
    id: 6,
    text: "Tu as le don de transformer les moments ordinaires en souvenirs extraordinaires.",
    category: "moments"
  },
  {
    id: 7,
    text: "Ta générosité sans limites a façonné la personne que je suis aujourd'hui.",
    category: "générosité"
  },
  {
    id: 8,
    text: "Ton rire contagieux est le remède à tous mes soucis.",
    category: "humour"
  },
  {
    id: 9,
    text: "La force tranquille que tu dégages m'a toujours donné confiance pour affronter le monde.",
    category: "force"
  },
  {
    id: 10,
    text: "Ton amour inconditionnel est le plus beau cadeau que j'ai jamais reçu.",
    category: "amour"
  }
];

// Citations françaises
const frenchQuotes = [
  {
    id: 101,
    text: "Un père, c'est un bancal sublime qui marche entre deux béquilles : l'amour et l'autorité.",
    author: "Victor Hugo",
    source: "Les Misérables",
    category: "citation-fr"
  },
  {
    id: 102,
    text: "Le père est un dieu sur terre, car il est la providence de l'enfance.",
    author: "Honoré de Balzac",
    category: "citation-fr"
  },
  {
    id: 103,
    text: "Sans la paternité, l'homme serait seul au monde, car c'est elle qui le relie à l'éternité.",
    author: "Albert Camus",
    category: "citation-fr"
  },
  {
    id: 104,
    text: "Être père, ce n'est pas donner la vie, c'est donner de l'amour toute la vie.",
    author: "Antoine de Saint-Exupéry",
    category: "citation-fr"
  },
  {
    id: 105,
    text: "Un bon père vaut mieux qu'une centaine de maîtres d'école.",
    author: "Jean de La Fontaine",
    category: "citation-fr"
  }
];

// Citations internationales
const internationalQuotes = [
  {
    id: 201,
    text: "C'est un père sage qui connaît son propre enfant.",
    author: "William Shakespeare",
    source: "Angleterre",
    category: "citation-int"
  },
  {
    id: 202,
    text: "Quand j'avais quatorze ans, mon père était si ignorant que je supportais à peine sa présence. Mais à vingt et un ans, j'étais stupéfait de voir tout ce qu'il avait appris en sept ans.",
    author: "Mark Twain",
    source: "États-Unis",
    category: "citation-int"
  },
  {
    id: 203,
    text: "Le père est le pilier de la famille, son amour est le fondement sur lequel tout le reste est construit.",
    author: "Khalil Gibran",
    source: "Liban",
    category: "citation-int"
  },
  {
    id: 204,
    text: "Le père qui ne sait pas enseigner à son fils ses propres devoirs est aussi coupable que celui-ci s'il les néglige.",
    author: "Confucius",
    source: "Chine",
    category: "citation-int"
  },
  {
    id: 205,
    text: "Un bon père est celui qui sait pardonner, guider et aimer sans condition.",
    author: "Nelson Mandela",
    source: "Afrique du Sud",
    category: "citation-int"
  }
];

// Proverbes et sagesses populaires
const proverbs = [
  {
    id: 301,
    text: "Un vieillard assis voit plus loin qu'un jeune homme debout.",
    source: "Proverbe africain",
    category: "proverbe"
  },
  {
    id: 302,
    text: "Le père plante l'arbre, l'enfant profite de l'ombre.",
    source: "Proverbe chinois",
    category: "proverbe"
  },
  {
    id: 303,
    text: "Dieu ne pouvait être partout, alors il a créé les pères.",
    source: "Proverbe juif",
    category: "proverbe"
  },
  {
    id: 304,
    text: "Le cœur d'un père est le chef-d'œuvre de la nature.",
    source: "Proverbe indien",
    category: "proverbe"
  },
  {
    id: 305,
    text: "Le père est ce roc immuable contre lequel l'enfant se blottit, et quand la tempête le frappe, c'est dans ses bras qu'il trouve asile.",
    author: "Charles Baudelaire",
    category: "proverbe"
  },
  {
    id: 306,
    text: "Tout homme peut être un père, mais il faut être quelqu'un de spécial pour être un papa.",
    author: "Barack Obama",
    category: "proverbe"
  }
];

// Catégories pour les compliments originaux
const categories = [
  { id: "all", name: "Tous" },
  { id: "inspirant", name: "Inspirants" },
  { id: "sagesse", name: "Sagesse" },
  { id: "courage", name: "Courage" },
  { id: "soutien", name: "Soutien" },
  { id: "famille", name: "Famille" },
  { id: "amour", name: "Amour" },
  { id: "humour", name: "Humour" },
  { id: "force", name: "Force" },
  { id: "générosité", name: "Générosité" },
  { id: "moments", name: "Moments" }
];

// Onglets principaux
const tabs = [
  { id: "compliments", name: "Compliments" },
  { id: "citation-fr", name: "Citations françaises" },
  { id: "citation-int", name: "Citations internationales" },
  { id: "proverbe", name: "Proverbes & Sagesses" }
];

const Compliments = () => {
  const [activeTab, setActiveTab] = useState("compliments");
  const [activeCategory, setActiveCategory] = useState("all");
  const [copiedId, setCopiedId] = useState(null);
  
  const handleCopyClick = (text, id) => {
    navigator.clipboard.writeText(text);
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 2000);
  };
  
  // Filtrer les compliments en fonction de l'onglet et de la catégorie actifs
  const getFilteredItems = () => {
    switch (activeTab) {
      case "compliments":
        return activeCategory === "all" 
          ? complimentsList 
          : complimentsList.filter(item => item.category === activeCategory);
      case "citation-fr":
        return frenchQuotes;
      case "citation-int":
        return internationalQuotes;
      case "proverbe":
        return proverbs;
      default:
        return [];
    }
  };
  
  const filteredItems = getFilteredItems();
  
  return (
    <ComplimentsContainer>
      <ComplimentsTitle>Mes compliments pour toi, Papa</ComplimentsTitle>
      <ComplimentsDescription>
        Papa, voici la page compliment et citation. Une page pour laquelle tu pourras te référer pour te remonter le moral ou pour renforcer ton bien être. Elle est le reflet de mon admiration pour toi qui a toujours été présent pour moi.
      </ComplimentsDescription>
      
      {/* Onglets principaux */}
      <TabsContainer>
        {tabs.map(tab => (
          <TabButton 
            key={tab.id}
            active={activeTab === tab.id}
            onClick={() => {
              setActiveTab(tab.id);
              setActiveCategory("all");
            }}
          >
            {tab.name}
          </TabButton>
        ))}
      </TabsContainer>
      
      {/* Filtres pour les compliments originaux */}
      {activeTab === "compliments" && (
        <FilterContainer>
          {categories.map(category => (
            <FilterButton 
              key={category.id}
              active={activeCategory === category.id}
              onClick={() => setActiveCategory(category.id)}
            >
              {category.name}
            </FilterButton>
          ))}
        </FilterContainer>
      )}
      
      <ComplimentsGrid>
        {filteredItems.map(item => (
          <ComplimentCard key={item.id}>
            <ComplimentText>{item.text}</ComplimentText>
            
            {/* Afficher l'auteur et la source pour les citations */}
            {(activeTab !== "compliments" && item.author) && (
              <AuthorText>
                — {item.author}
                {item.source && <SourceText> ({item.source})</SourceText>}
              </AuthorText>
            )}
            
            {/* Afficher uniquement la source pour les proverbes sans auteur */}
            {(activeTab !== "compliments" && !item.author && item.source) && (
              <AuthorText>
                — {item.source}
              </AuthorText>
            )}
            
            <CopyButton 
              onClick={() => handleCopyClick(item.text, item.id)}
              title="Copier ce texte"
            >
              {copiedId === item.id ? "✓" : "📋"}
            </CopyButton>
          </ComplimentCard>
        ))}
      </ComplimentsGrid>
    </ComplimentsContainer>
  );
};

export default Compliments;
